import Roles from "@/shared/Roles";

const AuthService = {
    role: Roles,
    require2fa: [
        Roles.Hod, Roles.Dean, Roles.StudentManagementAdministrative, Roles.Bursar,
        Roles.AdmissionOfficer, Roles.BiometricOfficer, Roles.ResultAdmin,
        // Added so the officer guard also forces TOTP for these enrolled-gate roles.
        Roles.DepartmentOfficer, Roles.ScreeningVerificationOfficer, Roles.ClearanceOfficial,
        Roles.ChangedOfProgramme, Roles.DeanSpgs, Roles.SecretarySpgs
    ],

    // Roles that must register a passkey (in addition to TOTP) before using the system.
    requirePasskey: [
        Roles.DepartmentOfficer, Roles.Hod, Roles.Bursar, Roles.AdmissionOfficer,
        Roles.ScreeningVerificationOfficer, Roles.ClearanceOfficial, Roles.ChangedOfProgramme,
        Roles.StudentManagementAdministrative, Roles.DeanSpgs, Roles.SecretarySpgs,
        Roles.Admin, Roles.SuperAdmin
    ],

    academicClosedRoles: [
        Roles.Hod, Roles.Dean, Roles.DepartmentOfficer, Roles.FacultyOfficer
    ]
}

export default AuthService;
